import React, {
  ReactElement,
  useEffect,
  useState,
} from 'react';
import './LeftSideBar.less';
import { useHistory } from 'react-router-dom';
import { Layout, Menu, Space, Tag } from 'antd';
import ReimbursementChart from '../../shared/components/charts/ReimbursementChart';
import {
  RELEASE_VERSION,
  COPY_RIGHT_TEXT,
  MAIN_OPTIONS,
  NAV_SERVICES,
  FUNDED_CLAIMS_TYPES,
} from '../../shared/constants/commonConstants';
import { SideNavServiceOptions } from '../../shared/models/common.model';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { fetchReimbursementData } from '../../store/actions/leftSideBarAction';
import { canActivate, openInNewTabWithAuth } from '../../utils/utility';
import { ApplicationDetailModel } from '../../store/models/applicationDetailModel';
import IHXCreditUtilized from './IHXCreditUtilized';
import ApplicationDetail from '../../shared/services/applicationDetail.service';
import { authFeatureConstants } from '../../shared/constants/commonConstants';
import { customGTMEvent } from '../../modules/crm/inPatient/service/crmUtils';

const LeftSideBar = ({ onServiceChange, sidebarHover }: any): ReactElement => {
  const appService = ApplicationDetail.instance;
  const hospitalDetails = appService.getHospitalDetail();
  const onBoardingToken = useSelector((state: RootState): any => state.auth.token);
  const history = useHistory();
  const { pathname } = history.location;
  const { Item } = Menu;
  const [selectedService, setSelectedService] = useState(pathname);
  const filteredNavServices = NAV_SERVICES.filter(
    (nav: SideNavServiceOptions): boolean =>
      MAIN_OPTIONS.indexOf(nav.Id) >= 0 && canActivate(nav.accessCheckKeyword),
  );
  const dispatch = useDispatch();
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const providerId = appdetails.getProviderId();
  const reimbursementchartData = useSelector(
    ({ sideBarHeader: { reimbursementChartDetails } }: any): any =>
      reimbursementChartDetails,
  );
  const isShowProviderCredit = hospitalDetails?.providerConfigurableProperties?.isShowProviderCredit;

  useEffect((): void => {
    if (providerId) {
      // TODO: For now this is static but in future it should be allPayers id
      const payerId = 516572;
      dispatch(fetchReimbursementData({ payerId }));
    }
  }, [providerId]);

  useEffect((): void => {
    const path: string = pathname.split('/')[1];
    if (path !== selectedService) {
      setSelectedService(path);
    }
  }, [pathname, selectedService]);

  const handleClick = (e: any): void => {
    // Case: Skip redirection for specific keys
    if (FUNDED_CLAIMS_TYPES?.includes(e.key)) {
      customGTMEvent({
        event: `Click on ${e.key}`,
      });
      return;
    }
    if (e.key === 'onboarding' && onBoardingToken) {
      openInNewTabWithAuth(`${process.env.REACT_APP_ONBOARDING_SERVICE_URL}`, onBoardingToken);
      return;
    }
    setSelectedService(e.key);
    onServiceChange(e.key);
    customGTMEvent({
      event: `Click on ${e.key}`,
    });
  };

  return (
    <Layout.Sider className="left-sidebar" collapsible={true} collapsed={!sidebarHover} width={254} collapsedWidth={51}
      style={{ paddingBottom: 0 }}
    >
      <div className="select-main-service">
        <Menu
          defaultSelectedKeys={[pathname.split('/')[1]]}
          defaultOpenKeys={['1']}
          selectedKeys={[pathname.split('/')[1]]}
          onClick={handleClick}
          mode="inline"
          inlineIndent={15}
        >
          {filteredNavServices?.length &&
            filteredNavServices.map(
              (
                { Icon: SvgIcon, Name, Id, Updates, left }: any,
              ): ReactElement => (
                <Item
                  key={Id}
                  title={Name}
                  icon={Updates && !sidebarHover ?
                    <div className="circle-icon"><img src={SvgIcon} loading="lazy" alt="" /></div> : <img src={SvgIcon} loading="lazy" alt="" />}
                  className="left-menu-list">
                  <span className="left-side-bar-items">{Name}</span>
                  {Updates ?
                    <Space size={[0, 0]}>&nbsp;<div className="tag-padding"><Tag className="curved-tag"
                      style={{ left }}>{Updates}</Tag></div></Space>
                    : null}
                </Item>
              ),
            )}
        </Menu>
      </div>
      {
        canActivate(authFeatureConstants.CLAIMS_CREDITS_UTILIZATION) &&
        <div className="sidebar-empty-place">
          <div className="sidebar-analytics" style={{ display: sidebarHover ? 'block' : 'none' }}>
            <ReimbursementChart
              title={<b>Claims for this month</b>}
              chartData={reimbursementchartData}
            />
            <div className="devider" />
            <IHXCreditUtilized />
          </div>
        </div>
      }
      <div className={`side-nav-copyright ${isShowProviderCredit && 'blue-border'} ${sidebarHover && 'side-nav-copyright-open'}`}
      > {sidebarHover && <><div>{RELEASE_VERSION}</div><div>{COPY_RIGHT_TEXT}</div></>}
        </div>
    </Layout.Sider>
  );
};

export default LeftSideBar;
